// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3849":"28ef5921","4477":"e8542d17","4781":"94ddbfc7","5342":"53437ee6","5896":"94ddbfc7","5908":"94ddbfc7","9471":"94ddbfc7"}[chunkId] + ".chunk.css";
};